// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uploadManagerDiv
{
    position: absolute;
    background-color: var(--dialog-content-backcolor);
    color: white;
    border-radius : 8px;
    display: flex;
    flex-direction: column;
    -webkit-user-select: none;
            user-select: none;

    border: solid;
    border-width: 2px;
    border-color: var(--default-icon-color);

    z-index: 20;

}



.uploadManagerTitle
{
    padding-top: 5px;
    background-color: var(--dialog-title-backcolor);
    border-top-left-radius : 8px;
    border-top-right-radius : 8px;
    color: white;
    height: 20px;
    font-size: 12px;
    text-align: center;
    display: flex;
}
.uploadManagerCloseButton
{
    width: 20px;
    background-color: transparent;
}
.uploadManagerTitleText
{
    background-color: transparent;
    width: calc(100% - 30px);

}

.oneuploaddiv
{
    padding-left: 5px;
    padding-right: 5px;
    font-size: 10px;
    border-style: solid;
    border-radius: 3px;
    border-width: 1px;
    border-color: #606060;
    margin: 4px;
    
    color: white;
}


.oneuploadpb1
{
    width: 100%; 
    background-color: #404040; 
    mix-blend-mode: difference;
    border-radius: 4px; 
    overflow: hidden; 
    margin-top: 3px;
    margin-bottom: 3px;
}
.oneuploadpb2
{
    font-size: 9px;   
    background-color: black; 
    mix-blend-mode: difference;
    color:white;
    text-align: center;
    height: 12px; 
    background-color: var(--default-icon-color);
}
`, "",{"version":3,"sources":["webpack://./src/upload/upload.css"],"names":[],"mappings":"AAAA;;IAEI,kBAAkB;IAClB,iDAAiD;IACjD,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,yBAAiB;YAAjB,iBAAiB;;IAEjB,aAAa;IACb,iBAAiB;IACjB,uCAAuC;;IAEvC,WAAW;;AAEf;;;;AAIA;;IAEI,gBAAgB;IAChB,+CAA+C;IAC/C,4BAA4B;IAC5B,6BAA6B;IAC7B,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,aAAa;AACjB;AACA;;IAEI,WAAW;IACX,6BAA6B;AACjC;AACA;;IAEI,6BAA6B;IAC7B,wBAAwB;;AAE5B;;AAEA;;IAEI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB,WAAW;;IAEX,YAAY;AAChB;;;AAGA;;IAEI,WAAW;IACX,yBAAyB;IACzB,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;AACA;;IAEI,cAAc;IACd,uBAAuB;IACvB,0BAA0B;IAC1B,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,2CAA2C;AAC/C","sourcesContent":[".uploadManagerDiv\n{\n    position: absolute;\n    background-color: var(--dialog-content-backcolor);\n    color: white;\n    border-radius : 8px;\n    display: flex;\n    flex-direction: column;\n    user-select: none;\n\n    border: solid;\n    border-width: 2px;\n    border-color: var(--default-icon-color);\n\n    z-index: 20;\n\n}\n\n\n\n.uploadManagerTitle\n{\n    padding-top: 5px;\n    background-color: var(--dialog-title-backcolor);\n    border-top-left-radius : 8px;\n    border-top-right-radius : 8px;\n    color: white;\n    height: 20px;\n    font-size: 12px;\n    text-align: center;\n    display: flex;\n}\n.uploadManagerCloseButton\n{\n    width: 20px;\n    background-color: transparent;\n}\n.uploadManagerTitleText\n{\n    background-color: transparent;\n    width: calc(100% - 30px);\n\n}\n\n.oneuploaddiv\n{\n    padding-left: 5px;\n    padding-right: 5px;\n    font-size: 10px;\n    border-style: solid;\n    border-radius: 3px;\n    border-width: 1px;\n    border-color: #606060;\n    margin: 4px;\n    \n    color: white;\n}\n\n\n.oneuploadpb1\n{\n    width: 100%; \n    background-color: #404040; \n    mix-blend-mode: difference;\n    border-radius: 4px; \n    overflow: hidden; \n    margin-top: 3px;\n    margin-bottom: 3px;\n}\n.oneuploadpb2\n{\n    font-size: 9px;   \n    background-color: black; \n    mix-blend-mode: difference;\n    color:white;\n    text-align: center;\n    height: 12px; \n    background-color: var(--default-icon-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
